export default __webpack_public_path__ + "static/media/iQagent.14a7967e.png";